import { Amount } from "@/components/common/amount"

interface TxnRowProps {
  date: string
  description: string
  amount: number
  type: "debit" | "credit"
  note?: string
  checked?: boolean
  onCheck?: () => void
}

export function TxnRow({ date, description, amount, type, note, checked, onCheck }: TxnRowProps) {
  const hasCheckbox = onCheck !== undefined

  return (
    <div
      className="grid items-center gap-2.5 border-b border-border-subtle py-2.5 last:border-b-0"
      style={{ gridTemplateColumns: hasCheckbox ? "16px 1fr auto" : "1fr auto" }}
    >
      {hasCheckbox && (
        <button
          type="button"
          onClick={onCheck}
          className="flex size-4 shrink-0 items-center justify-center rounded-[4px] border-[1.5px] transition-colors"
          style={{
            background: checked ? "var(--accent-amber)" : "var(--bg-elevated)",
            borderColor: checked ? "var(--accent-amber)" : "var(--border-default)",
            color: checked ? "var(--text-inverse)" : undefined,
            fontSize: 9,
            fontWeight: 700,
          }}
        >
          {checked && "✓"}
        </button>
      )}

      <div className="min-w-0">
        <p className="truncate text-[12px] font-medium text-text-primary">{description}</p>
        <div className="mt-0.5 flex items-center gap-1.5">
          <span className="font-mono text-[10px] text-text-muted">{date}</span>
          {note && (
            <span className="text-[10px] italic" style={{ color: "var(--cat-wants)" }}>
              · {note}
            </span>
          )}
        </div>
      </div>

      {/* Through <Amount> so the "Hide amounts" mask applies (PAISA-PRIV-01) and
          debits stay neutral with a minus sign (PAISA-AMT-02). */}
      <Amount
        value={type === "debit" ? -Math.abs(Number(amount)) : Math.abs(Number(amount))}
        showSign
        precise={!Number.isInteger(Number(amount))}
        className="shrink-0 text-body font-semibold"
      />
    </div>
  )
}
